module.exports = __webpack_public_path__ + "static/media/time_1.db8ef63c.svg";